import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { Plan } from '@teetsh/app/src/types/plan';
import { PLAN_KEY } from './useGetPlans';

function getPlan(planKey: string, locale?: string) {
  const params = new URLSearchParams();
  if (locale) {
    params.append('lng', locale);
  }
  return request(`/plans/${planKey}`, {
    method: 'GET',
    params,
  }).then<Plan>(res => res);
}

export function useGetPlan(planKey: string, locale?: string) {
  return useQuery({
    queryKey: [PLAN_KEY, planKey, locale],
    queryFn: () => getPlan(planKey, locale),
    refetchOnWindowFocus: false,
  });
}
